import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';

import Box from '@mui/joy/Box';
import Chip from '@mui/joy/Chip';
import Divider from '@mui/joy/Divider';
import { Typography } from '@mui/joy';

import {DateOrTime} from './Date';
import Link from './Link';

import useUserIdentity from 'hooks/useUserIdentity';


import { WorkItemTitleText } from './ClockReport';
import useCollabs from 'hooks/useCollabs';
import useClock from 'hooks/useClock';


import { CollaboratorsProps } from 'stores/collaborators_store';
import { CollabInviteProps } from 'stores/collab_invite_store';
import { ClockedInChip } from './RequestListItem';
import { ListicleWorkItemLastAction } from './ListicleWorkItem';

// import { Tooltip } from '@mui/material';

{/*
const SelectedOptions = observer(({ invite }: { invite: CollabInviteProps  }) => {
    const { currentIdentity }  = useContext(UserIdentityContext);
    const { acceptCollabInvite } = useCollabInvite();
    const workKey = useWorkKey();

    const [selectedIdentityKey, _] = useState(currentIdentity.key);
    const navigate = useNavigate();


    function doAccept() {
        if(!workKey) {
            Error("Unable to accept, no identity loaded");
            return;
        }
        acceptCollabInvite(invite.key, selectedIdentityKey)
            .then((data) => {
                Success("Invite accepted. Let's get to work!");
                navigate(`/collab/${data.collab}`);
            });
    }

    function doBack() {
        window.history.back();
    }

    return (
        <Stack mt={2}>
            <Card>
                <CardContent>
                    <Stack spacing={1}>

                        <Typography level="title-lg">
                            Ready to work on this right now?
                        </Typography>

                        <Stack >
                            <Typography level="body-xs">
                                This is how you will appear to your collaborators.
                            </Typography>

                            <IdentityAvatar
                                identityKey={currentIdentity.key}
                                size="card" />

                        </Stack>
                    </Stack>
                </CardContent>

                <CardActions>
                    <Button
                        sx={{ ml: 'auto' }}
                        onClick={() => doBack()}
                        variant="outlined">Back</Button>
                    <Button
                        onClick={() => doAccept()}
                        color="primary">Accept</Button>
                </CardActions>
            </Card>
        </Stack>
    );
});
    */}

const CollabInviteAvailableListItemContent = observer(({ invite }: { invite: CollabInviteProps }) => {
    const { currentIdentity } = useUserIdentity();
    const { fetchCollab, getCollab } = useCollabs();
    const { currentClock } = useClock();

    const collab = getCollab(invite.collab);
    const clockedIn = currentClock?.associated_uuid && (currentClock?.associated_uuid == invite.associated_uuid);

    useEffect(() => {
        if(currentIdentity?.key) {
            fetchCollab(currentIdentity?.key, invite.collab);
        }
    }, [fetchCollab, invite.collab, currentIdentity?.key]);

    return (
        <ListItemButton
            sx={{
                borderRadius: 'lg',
                padding: 0,
                transition: 'background-color 0.8s',
            }}
            variant={clockedIn ? 'soft' : 'plain'}
            color={clockedIn ? 'primary' : 'neutral'}

        >
        <ListItem

                sx={{
                    px: 0,
                    margin:0,
                    width: '100%' }}
            >
                <Stack
                    sx={{ width: '100%' }}
                    spacing={1}
                    margin={1}
                >
                <Stack spacing={1}>

                <WorkItemTitleText associated_type={invite.associated_type || 'collab'} associated_uuid={invite.associated_uuid || invite.collab} />

                    </Stack>
                    <Stack
                        direction="row"
                        alignItems="flex-end"
                        spacing={1}
                        sx={{ '--Avatar-size': '18px' }}
                    >

                    { collab &&
                        <ListicleWorkItemLastAction item={collab} /> }


                        <Box flexGrow={1} />

                        <Stack direction="row"
                            spacing={1}

                            divider={<Divider orientation="vertical" />}>

                            {clockedIn && <ClockedInChip />}

                            {invite.variant == 'support' ?
                                <Chip color="danger" size="sm">
                                    Support
                                </Chip> :

                            <Chip variant="outlined" color="success" size="sm">
                                Collab
                            </Chip>
                            }

                            {collab?.date_created &&
                                <Typography level="body-xs">
                                    <DateOrTime ts={collab?.date_created}/>
                                </Typography>
                            }
                        </Stack>
                    </Stack>

                </Stack>



            </ListItem>


        </ListItemButton>

    );

});

const CollabInviteAvailableListItem = observer(({ invite }: { invite: CollabInviteProps | CollaboratorsProps }) => {
    const url = invite.cls == "collaborators" ? `/collab/${invite.collab}` : '/invite/' + invite.uuid;
    return (
        <Link to={url}>
            <CollabInviteAvailableListItemContent invite={invite as CollabInviteProps} />
        </Link>
    );
});

export default CollabInviteAvailableListItem;
